import React, { createContext, useContext, useEffect, useState } from "react";
import { getOrderTiming } from "../orderTiming";
import OrderTiming from "./OrderTiming";

const KitchenClock = createContext(null);
export const useKitchenNow = () => useContext(KitchenClock) ?? Date.now();

// One clock for every visible card. Ticks update only timing consumers, not the
// whole KDS screen, and never make API requests.
export const KitchenClockProvider = ({ active = true, children }) => {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    if (!active) return;
    const tick = () => setNow(Date.now());
    tick();
    const interval = setInterval(tick, 1000);
    const onVisibility = () => {
      if (!document.hidden) tick();
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [active]);
  return <KitchenClock.Provider value={now}>{children}</KitchenClock.Provider>;
};

const useOrderTiming = (order) => {
  const now = useContext(KitchenClock);
  return getOrderTiming(order, now ?? Date.now());
};

export const OrderCountdown = ({ order, showDescription = true }) => (
  <OrderTiming timing={useOrderTiming(order)} showDescription={showDescription} />
);

export default function TimedOrderCard({ order, className = "", children, ...props }) {
  const timing = useOrderTiming(order);
  return (
    <div {...props} className={`${className} kds-timing--${timing.tone}`}>
      {children}
    </div>
  );
}
